import React from 'react';
import { Instagram, Linkedin } from 'lucide-react';

const Footer = ({ t }) => (
  <footer className="bg-gray-900 text-white py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <div>
          <h3 className="text-2xl font-bold mb-4">
            <span className="text-blue-400">Pulso</span> Media Agency
          </h3>
          <p className="text-gray-400">{t.contact.description}</p>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4">{t.contact.contactTitle}</h4>
          <div className="space-y-2 text-gray-400">
            <p>Email: coachingpauasensio@gmail.com</p>
          </div>
        </div>
        <div>
          <h4 className="text-lg font-semibold mb-4">{t.contact.followTitle}</h4>
          <div className="flex gap-4">
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
              data-testid="footer-instagram-link"
            >
              <Instagram className="w-6 h-6" />
            </a>
            <a
              href="https://www.linkedin.com/in/pauasensio/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
              data-testid="footer-linkedin-link"
            >
              <Linkedin className="w-6 h-6" />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
        <p>{t.contact.copyright}</p>
      </div>
    </div>
  </footer>
);

export default Footer;
